import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, FileText, Printer } from 'lucide-react';

export const EmptyTemplate: React.FC = () => {
  const downloadEmptyTemplate = () => {
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>ESAS Assessment - Leere Vorlage</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; margin-bottom: 30px; }
            .patient-info { margin-bottom: 20px; }
            .patient-info div { margin-bottom: 10px; border-bottom: 1px solid #ccc; padding-bottom: 5px; }
            .symptoms-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
            .symptoms-table th, .symptoms-table td { border: 1px solid #ccc; padding: 12px; text-align: left; }
            .symptoms-table th { background-color: #f5f5f5; }
            .score-boxes { display: flex; gap: 5px; }
            .score-box { width: 25px; height: 25px; border: 1px solid #ccc; display: inline-block; text-align: center; line-height: 23px; }
            .legend { margin-bottom: 20px; }
            .legend-item { display: inline-block; margin-right: 20px; padding: 5px 10px; border: 1px solid #ccc; }
            .score-0-2 { background-color: #dcfce7; }
            .score-3-6 { background-color: #fef3c7; }
            .score-7-10 { background-color: #fee2e2; }
            .signature-area { margin-top: 30px; border-bottom: 1px solid #ccc; padding-bottom: 5px; }
            @media print { body { margin: 0; } }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Modifiziertes ESAS</h1>
            <h2>(Edmonton Symptom Assessment System)</h2>
          </div>
          
          <div class="patient-info">
            <div><strong>Name / Vorname:</strong> _________________________________</div>
            <div><strong>Geburtsdatum:</strong> _________________________________</div>
            <div><strong>Datum:</strong> _________________________________</div>
            <div><strong>Kürzel für Erhebung:</strong> P ☐ &nbsp;&nbsp; PH ☐ &nbsp;&nbsp; F ☐</div>
          </div>

          <div class="legend">
            <div class="legend-item score-0-2">Grad 0-2: Symptom vorhanden, jedoch ohne Behandlungsbedarf</div>
            <div class="legend-item score-3-6">Grad 3-6: Symptom vorhanden, sollte behandelt werden</div>
            <div class="legend-item score-7-10">Grad 7-10: Symptom vorhanden, sofortiger Handlungsbedarf</div>
          </div>

          <table class="symptoms-table">
            <thead>
              <tr>
                <th style="width: 30%;">Symptom</th>
                <th style="width: 50%;">Bewertung (0-10)</th>
                <th style="width: 20%;">Datum</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Schmerz</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Erschöpfung</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Übelkeit</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Verstopfung</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Angst (Innere Unruhe)</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Benommenheit (Schwindel)</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Appetitlosigkeit</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Wohlbefinden</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Atemnot</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td><strong>Weitere Beschwerden</strong></td>
                <td>
                  <div class="score-boxes">
                    ${Array.from({length: 11}, (_, i) => `<div class="score-box">${i}</div>`).join('')}
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <div>
            <strong>Weitere Beschwerden (Details):</strong>
            <div style="border: 1px solid #ccc; height: 80px; margin-top: 10px;"></div>
          </div>

          <div class="signature-area">
            <strong>Ausgeführt durch: (Visum)</strong> _________________________________
          </div>

          <div style="margin-top: 50px; font-size: 12px; color: #666;">
            <p>Kürzel für Erhebung: P = Patient/in – PH = Patient/in mit Hilfe – F = med. Fachperson</p>
            <p>Modifiziertes ESAS (Edmonton Symptom Assessment System) / Aktuelle Version: 06/2022</p>
            <p>Quelle: © modifiziert nach Spez. Palliativ-Onkologie Pflege Brückendienst, Spitex Stadt Luzern</p>
            <p>Herausgeber: Palliativ Luzern, Schachenstrasse 9, 6010 Kriens, Telefon 041 511 28 20, info@palliativ-luzern.ch, www.palliativ-luzern.ch</p>
          </div>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  return (
    <Card className="max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="w-5 h-5" />
          Leere ESAS-Vorlage
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-gray-600">
          Laden Sie eine leere ESAS-Vorlage herunter oder drucken Sie sie aus, 
          um sie manuell auszufüllen.
        </p>
        
        <div className="flex gap-3">
          <Button onClick={downloadEmptyTemplate} className="flex items-center gap-2">
            <Printer className="w-4 h-4" />
            Leere Vorlage drucken
          </Button>
          <Button onClick={downloadEmptyTemplate} variant="outline" className="flex items-center gap-2">
            <Download className="w-4 h-4" />
            Leere Vorlage herunterladen
          </Button>
        </div>

        <div className="bg-blue-50 p-4 rounded-lg">
          <h4 className="font-semibold text-blue-800 mb-2">Hinweise zur Verwendung:</h4>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>• Markieren Sie die entsprechenden Bewertungsfelder (0-10)</li>
            <li>• 0 = kein Symptom, 10 = stärkstes vorstellbares Symptom</li>
            <li>• Verwenden Sie die Farbkodierung als Behandlungsrichtlinie</li>
            <li>• Dokumentieren Sie zusätzliche Beschwerden im Textfeld</li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};